module.exports = __webpack_public_path__ + "img/share.678093de.svg";